module.exports = DOMAIN_NAME;


//////////////////
// WEBPACK FOOTER
// external "DOMAIN_NAME"
// module id = 337Q
// module chunks = 58